import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PageTitle = ({ motherMenu, activeMenu, pageContent }) => {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const path = window.location.pathname.split("/");

  return (
    <div
      className="row page-titles mx-0"
      dir={isArabic ? "rtl" : "ltr"}
      style={{ textAlign: isArabic ? "right" : "left" }}
    >
      <div className={`col-sm-6 p-md-0 ${isArabic ? "text-sm-end" : "text-sm-start"}`}>
        <div className="welcome-text">
          <p className="mb-0">
            {pageContent || "Your business dashboard template"}
          </p>
        </div>
      </div>

      <div
        className={`col-sm-6 p-md-0 d-flex ${
          isArabic ? "justify-content-sm-start" : "justify-content-sm-end"
        } mt-2 mt-sm-0`}
      >
        <ol
          className="breadcrumb"
          style={{
            flexDirection: isArabic ? "row-reverse" : "row",
          }}
        >
          <li className="breadcrumb-item">
            <Link to={`/${path[path.length - 1]}`}>{motherMenu}</Link>
          </li>
          <li className="breadcrumb-item active">
            <Link to={`/${path[path.length - 1]}`}>{activeMenu}</Link>
          </li>
        </ol>
      </div>
    </div>
  );
};

export default PageTitle;
